import { useCallback, useEffect, useState } from 'react';
import { HorizontalTabProps } from '../../../../components/tabs-horizontal/TabsHorizontal';
import styled from 'styled-components';
import Table from '../../../../blocks/table/TableClient';
import OrdersService from '../../../../services/OrdersService';
import { OrderDTO } from '../../../../api/api';
import { useDispatch, useSelector } from 'react-redux';
import { selectUserProfile } from '../../../../stateManagement/reducers/userProfileReducer';
import { log } from '../../../../utils/logging/log';
import NotificationService from '../../../../services/NotificationService';
import useOrderTable from '../orders-tab/useOrderTable';
import { setSelectedOrderReceipt } from '../../../../stateManagement/reducers/orderGoodsReducer';

interface Props extends HorizontalTabProps {
  handleOpenOrderReceipt: () => void;
}

const AutomaticOrders = (props: Props) => {
  const [loading, setLoading] = useState(false);
  const [mrpOrders, setMrpOrders] = useState<OrderDTO[]>([]);
  const { handleOpenOrderReceipt } = props;

  const warehouseId = useSelector(selectUserProfile).userProfile.vehicle?.vehicleId;
  const dispatch = useDispatch();

  useEffect(() => {
    if (!warehouseId) return;
    setLoading(true);
    OrdersService.getMrpOrdersByWarehouse(warehouseId)
      .then((data) => {
        setMrpOrders(data);
      })
      .catch((e) => {
        log(e);
        NotificationService.error('Kunne ikke hente returordere');
      })
      .finally(() => {
        setLoading(false);
      });
  }, [warehouseId]);

  const openOrderReceipt = useCallback(
    (order?: OrderDTO) => {
      if (!order) return;
      dispatch(setSelectedOrderReceipt(order));
      handleOpenOrderReceipt();
    },
    [dispatch, handleOpenOrderReceipt]
  );

  const tableInstance = useOrderTable(mrpOrders, openOrderReceipt, {
    sortByColumn: 'expectedReceiptDate',
    desc: false // For some reason, this is reversed (true = asc, false = desc)
  });

  return (
    <TableContainer>
      <Table loading={loading} tableInstance={tableInstance} alwaysShowSort noPadding showPagination></Table>
    </TableContainer>
  );
};

const TableContainer = styled.div`
  width: 100%;
`;

export default AutomaticOrders;
